import React from 'react';

import { ColorsToRoutePointsOnRoutesTracker } from '../../../../components/Map/providers/enums'
import { useSelector } from 'react-redux';
import { useIntl } from "react-intl";
import './style.scss'

/*********************************************************
 * Module:  Realtime Maps
 * Class associated to the speed override legends
 ********************************************************/
const ColorBox = ({ color, name, isLast }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: isLast ? 0 : "8px",
      }}
    >
      <div
        style={{
          backgroundColor: color,
          width: "18px",
          height: "18px",
          marginRight: "10px",
          border: "2px solid #fff",
          borderRadius: "50%",
          flexShrink: 0,
          boxShadow: "0 0 0 1px rgba(0,0,0,0.08)",
        }}
      ></div>
      <div
        style={{
            height: "24px",
            display: "flex",
            alignItems: "center",
            color: "#3c4043",
            fontWeight: "400",
            fontSize: "13px",
            whiteSpace: "nowrap",
        }}
      >{name}</div>
    </div>
);

const RoutesInfoMap = () => {

    const { user: { isKph }, user } = useSelector((state) => state.securityRedux);
    const { messages } = useIntl();

    return(
    <div>
        {
            ColorsToRoutePointsOnRoutesTracker.map((item, index) => {
                return (
                  <ColorBox key={index} color={item.color} name={messages[item.messages]} isLast={index === ColorsToRoutePointsOnRoutesTracker.length - 1} />
                )
            })
        }
    </div>
    )
};

export default RoutesInfoMap;